/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, { Component } from 'react';
import '../style.scss';
import { connect } from 'react-redux';
import {
  nextQuestion, prevQuestion, continueSurvey, speak, beelineText, updateSurveyAnswer, clearAnswers,
} from '../actions';
import ProgressBar from '../components/ProgressBar';
import Check from '../assets/quiz1/check.svg';

const optionText = [
  'Not Typical of Me',
  'Somewhat Typical of Me',
  'Neutral',
  'Mostly Typical of Me',
  'Very Typical of Me',
];

class SurveyQuestion extends Component {
  constructor() {
    super();
    this.state = {
      showTutorial: true,
    };
  }

  componentDidMount() {
    this.props.continueSurvey(this.props.userid, this.props.match.params.surveyid, this.props.history);
    this.props.beelineText();
  }

  componentDidUpdate() {
    this.props.beelineText();
  }

  componentWillUnmount() {
    this.props.clearAnswers();
  }

  handleChange = (i) => {
    this.props.updateSurveyAnswer(this.props.currQuestion.question_id, i, this.props.answers);
  }

  renderOptionCols = () => {
    return [0, 1, 2, 3, 4].map((i) => {
      const option = this.props.currQuestion[`option_${i}`];
      let image;
      if (i !== 1 && i !== 3) {
        try {
          image = require(`../assets/quiz${this.props.match.params.surveyid}/Q${this.props.currQuestion.question_id}-${i}.svg`);
        } catch (error) {
          console.log(`failed to load image at ../assets/quiz${this.props.match.params.surveyid}/Q${this.props.currQuestion.question_id}-${i}.svg`);
        }
      }
      return (
        <div className="question-col-container">
          <div
            className={`question-col ${this.props.answers[this.props.currQuestion.question_id] === i ? 'selected-question' : ''}`}
            name={i}
            onClick={() => this.handleChange(i)}
            key={i}
          >
            {i % 2 === 0 ? (
              <div className="row-container">
                <img
                  src={image}
                  alt={optionText[i]}
                />
              </div>
            ) : null}
            <p
              onClick={this.props.speak}
              className={`option-text color ${this.props.speechEnabled && 'bolded'}`}
            >
              {option}
            </p>
          </div>
          <div
            className="question-circle selected-question-circle"
            onClick={() => this.handleChange(i)}
          >
            {this.props.answers[this.props.currQuestion.question_id] === i
            && <img src={Check} alt="check" />}
          </div>
        </div>
      );
    });
  }

  nextQuestion = () => {
    if (this.props.currQuestion.question_id in this.props.answers) {
      this.props.nextQuestion(
        this.props.userid,
        this.props.match.params.surveyid,
        this.props.currQuestion.question_id,
        this.props.answers[this.props.currQuestion.question_id],
        this.props.currQuestion.general_result,
        this.props.currQuestion.omit,
        this.props.currQuestion.corresponding_results,
        this.props.history,
      );
    }
  }

  prevQuestion = () => {
    this.props.prevQuestion(
      this.props.userid,
      this.props.match.params.surveyid,
      this.props.currQuestion.question_id,
    );
  }

  render() {
    // UPDATE THIS ONCE MORE SURVEYS ARE CREATED
    if (this.props.match.params.surveyid >= 2) {
      return (
        <div onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>The survey you are trying to access has not been created yet.</div>
      );
    } else if (this.props.currQuestion === null) {
      return (
        <div onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>Loading</div>
      );
    } else {
      const survey = this.props.surveys[this.props.match.params.surveyid];
      if (Object.keys(this.props.answers).length === 0 && this.state.showTutorial) {
        return (
          <div className="survey-tutorial-outer">
            <button type="button" className="survey-button" onClick={() => this.props.history.push('/dashboard')}>Menu</button>
            <div className="survey-tutorial-container">
              <h3>Welcome to the <b>{survey.name}</b> survey!</h3>
              <p>In this survey, you will be given a series of statements describing your everyday workflow and work habits.</p>
              <p><b>With each statement, click on the response that aligns best with your personal situation.</b> The goal of this survey is for you to reflect how you work and figure out how you can improve upon your existing skillset!</p>
              <button
                type="button"
                className="survey-button"
                onClick={() => { this.setState({ showTutorial: false }); }}
              >
                Begin
              </button>
            </div>
          </div>
        );
      } else {
        return (
          <div className="survey-question-container">
            <button
              type="button"
              className="survey-button"
              onClick={() => this.props.history.push('/dashboard')}
            >
              Menu
            </button>
            <p onClick={this.props.speak} className={`color question-header ${this.props.speechEnabled && 'bolded'}`}>
              {this.props.currQuestion.question}
            </p>
            <div className="question-matrix">
              {this.renderOptionCols()}
              <div className="question-line" />
            </div>
            <div className="survey-button-container">
              {this.props.currQuestion.question_id !== 1
                ? (
                  <button
                    type="button"
                    className="survey-button"
                    onClick={this.prevQuestion}
                  >
                    {'< Previous'}
                  </button>
                )
                : null}
              <button
                type="button"
                className="survey-button"
                onClick={this.props.answers[this.props.currQuestion.question_id] !== undefined ? this.nextQuestion : null}
              >
                {this.props.currQuestion.question_id === survey.numQuestions
                  ? 'Submit'
                  : 'Next >'}
              </button>
            </div>
            <ProgressBar
              numCompleted={this.props.numCompleted}
              numQuestions={survey.numQuestions}
            />
          </div>
        );
      }
    }
  }
}

const mapStateToProps = (state) => (
  {
    currQuestion: state.survey.currQuestion,
    userid: state.user.userid,
    numCompleted: state.survey.numCompleted,
    surveys: state.survey.surveys,
    speaker: state.speech.speaker,
    speechEnabled: state.speech.enabled,
    answers: state.survey.answers,
  }
);

export default connect(mapStateToProps, {
  nextQuestion, prevQuestion, continueSurvey, speak, beelineText, updateSurveyAnswer, clearAnswers,
})(SurveyQuestion);
